import defineMessages from "../../../common/helpers/defineMessages";

const messages = defineMessages({
    title: {
        id: "shareModal.title",
    },
    share: {
        id: "shareModal.share",
    },
    link: {
        id: "shareModal.link",
    },
    noCopy: {
        id: "shareModal.noCopy",
    },
});

export default messages;
